import React from 'react'
import _ from 'lodash'

import {PickColumns} from 'bundle/dashboard/ui/PickColumns.jsx'
import {Select} from 'antd'

import {DeviceStore} from 'api/device'

_.flatMap = _.compose(_.flatten, _.map)

const provisioning = [
   {label: 'Active', value: 'active'},
   {label: 'Inactive', value: 'inactive'},
   {label: 'Passive', value: 'passive'}
]

const serialize2 = ([path, acc], v, k) => {
   const realpath = !k ? path : path.concat([k])

   if (_.isObject(v) && !_.isArray(v)) {
      _.each(v, (v2, k2) => serialize2([realpath, acc], v2, k2))

      return [path, acc]
   } else {
      acc[realpath.join('.')] = v.join(',')

      return [path, acc]
   }
}

const serialize = obj => serialize2([[], {}], obj)[1]

const fields = ['type', 'provisioned', 'proto/tm.firmware', 'proto/tm.hardware', 'proto/tm.part']

export class DeviceFacets extends React.Component {
   static get propTypes() {
      return {
         devices:          React.PropTypes.array,
         network:          React.PropTypes.object.isRequired,
         location:         React.PropTypes.object.isRequired,
         router:           React.PropTypes.object.isRequired,
         onChange:         React.PropTypes.func,
         onColumnsUpdate:  React.PropTypes.func.isRequired,
         columns:          React.PropTypes.array.isRequired,
         availableColumns: React.PropTypes.array
      }
   }
   constructor() {
      super()

      this.state = {
         facets: {}
      }

      this.updateFacets = this.updateFacets.bind(this)
   }

   componentWillMount() {
      this.updateFacets(_.pick(this.props.location.query, fields))
   }

   componentWillReceiveProps(next) {
      if (!_.eq(this.props.location.query, next.location.query)) {
         this.updateFacets(_.pick(next.location.query, fields))
      }
   }

   updateFacets(facets, setURL) {
      const {router, location} = this.props,
         filteredFacets = _.omit(facets, v => 0 === _.size(v) || (1 === _.size(v) && '' === v[0]))

      this.setState(
         {
            facets: _.mapValues(filteredFacets, (v, _k) => {
               return _.isArray(v) ? v : v.split(',')
            })
         },
         () => {
            if (this.props.onChange) {
               this.props.onChange(dev =>
                  _.all(
                     this.state.facets,
                     (v, k) => 0 === _.size(v) || -1 !== _.indexOf(v, _.get(dev, k)),
                  ),
               )
            }

            if (setURL) {
               let query = _.merge(_.omit(location.query, fields), serialize(this.state.facets))

               router.replace({...location, query})
            }
         },
      )
   }

   onFacetChange(facet, value, setURL) {
      let {facets} = this.state

      facets[facet] = value
      this.updateFacets(facets, setURL)
   }

   serializeFacetsToUrl(query) {
      const {router, location} = this.props

      router.replace({...location, query: serialize(query)})
   }

   render() {
      let {facets} = this.state,
         {network} = this.props

      let availableFacets = DeviceStore.facets([
         'proto/tm.hardware',
         'proto/tm.part',
         'proto/tm.firmware'
      ])

      return (
         <div className="facets">
            <div className="facet type">
               <h4>Filter by device type</h4>
               <Select
                  mode="multiple"
                  placeholder="Filter by device type"
                  value={facets.type || []}
                  onChange={v => this.onFacetChange('type', v, true)}
                  allowClear={true}
                  style={{width: '100%'}}
               >
                  {_.map(network.types, (type, idx) => (
                     <Select.Option key={idx} value={type}>{type}</Select.Option>
                  ))}
               </Select>
            </div>

            <div className="facet provisioning">
               <h4>Filter by provisioning</h4>
               <Select
                  mode="multiple"
                  placeholder="Filter by provisioning"
                  value={facets.provisioned || []}
                  onChange={v => this.onFacetChange('provisioned', v, true)}
                  allowClear={true}
                  style={{width: '100%'}}
               >

                  {_.map(provisioning, ({label, value}, idx) => (
                     <Select.Option key={idx} value={value}>{label || value}</Select.Option>
                  ))}
               </Select>
            </div>

            <div className="facet firmware">
               <h4>Filter by firmware revision</h4>
               <Select
                  mode="tags"
                  placeholder="Filter by Firmware"
                  value={facets['proto/tm.firmware'] || []}
                  onChange={v => this.onFacetChange('proto/tm.firmware', v, true)}
                  allowClear={true}
                  style={{width: '100%'}}
               >
                  {_.map(_.filter(availableFacets['proto/tm.firmware']), (value, idx) => (
                     <Select.Option key={idx} value={value}>{value}</Select.Option>
                  ))}
               </Select>
            </div>

            <div className="facet hardware">
               <h4>Filter by hardware version</h4>
               <Select
                  mode="tags"
                  placeholder="Filter by Hardware"
                  value={facets['proto/tm.hardware'] || []}
                  onChange={v => this.onFacetChange('proto/tm.hardware', v, true)}
                  allowClear={true}
                  style={{width: '100%'}}
               >
                  {_.map(_.filter(availableFacets['proto/tm.hardware']), (value, idx) => (
                     <Select.Option key={idx} value={value}>{value}</Select.Option>
                  ))}
               </Select>
            </div>

            <div className="facet part">
               <h4>Filter by Part #</h4>
               <Select
                  mode="tags"
                  placeholder="Filter by Part #"
                  value={facets['proto/tm.part'] || []}
                  onChange={v => this.onFacetChange('proto/tm.part', v, true)}
                  allowClear={true}
                  style={{width: '100%'}}
               >
                  {_.map(_.filter(availableFacets['proto/tm.part']), (value, idx) => (
                     <Select.Option key={idx} value={value}>{value}</Select.Option>
                  ))}
               </Select>
            </div>

            <div className="facet columns">
               <h4>Show Columns</h4>

               <PickColumns
                  onUpdate={this.props.onColumnsUpdate}
                  columns={this.props.columns}
                  options={this.props.availableColumns}
                  placeholder="key, device, proto/tm.firmware, ..."
               />
            </div>

         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/device-manager/DeviceFacets.jsx